// extracted by extract-css-chunks-webpack-plugin
module.exports = {"avatar":"avatar_1F4Lz","tag":"tag_1rhp-"};